import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { OneTimePayment, OneTimePaymentResult } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class OneTimePaymentApi {
    public static postOneTimePayment(_xmStore: XmStore, http: HttpClient, newPaymentInstrument: NewPaymentInstrument | ExistingCardWithAmount): Observable<OneTimePaymentResult> {
        return http.post('/account/payment', newPaymentInstrument, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: OneTimePaymentResult) => OneTimePaymentResult.create<OneTimePaymentResult>(response))
        );
    }

    public static saveOneTimePayment(_xmStore: XmStore, _http: HttpClient, payload: object): Observable<OneTimePayment> {
        return of(OneTimePayment.create<OneTimePayment>(payload));
    }

    public static getOneTimePayment(_xmStore: XmStore, _http: HttpClient, paymentDetails: OneTimePayment): Observable<OneTimePayment> {
        return of(paymentDetails);
    }
}

ModelBase.persistMapping[StoreAction.POST_ONE_TIME_PAYMENT] = OneTimePaymentApi.postOneTimePayment;
ModelBase.persistMapping[StoreAction.SAVE_ONE_TIME_PAYMENT_DATA] = OneTimePaymentApi.saveOneTimePayment;
ModelBase.fetchMapping[StoreAction.GET_ONE_TIME_PAYMENT] = OneTimePaymentApi.getOneTimePayment;
